import React, { useEffect } from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useTheme } from "@mui/material/styles";
import { useFormik } from "formik";
import AddressInputForm from "../forms/textField/AddressInputForm";
import { addressValidationSchema } from "../../utils/validationSchemas";
import {
  getFromLocalStorage,
  saveInLocalStorage,
} from "../../config/localStorage";

interface RecipientInformationProps {
  setComponentToDisplay: (selection: string) => void;
  //   setRecipientInfo: (info: Record<string, any>) => void;
}

const RecipientInformation: React.FC<RecipientInformationProps> = ({
  setComponentToDisplay,
  //   setRecipientInfo,
}) => {
  const theme = useTheme();

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      phoneNumber: "",
      email: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      zipcode: "",
      country: "",
    },
    validationSchema: addressValidationSchema,
    onSubmit: (values) => {
      saveInLocalStorage("recipientInfo", values);
      //   setRecipientInfo(values); // Pass recipient info to parent
      setComponentToDisplay("ORDERSUMMARY"); // Navigate to the next step
    },
  });

  const textFieldStyles = {
    "& .MuiInputLabel-root": {
      color: theme.palette.primary.dark,
    },
    "& .MuiInputBase-input": {
      color: theme.palette.primary.dark,
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: theme.palette.primary.dark,
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.dark,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.dark,
      },
    },
  };

  useEffect(() => {
    const tempRecipientInfo = getFromLocalStorage("recipientInfo");
    if (tempRecipientInfo?.firstName) {
      formik.setValues(tempRecipientInfo);
    }
  }, []);

  return (
    <Container>
      <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
        <IconButton
          onClick={() => setComponentToDisplay("CUSTOMERINFORMATION")}
          sx={{ color: theme.palette.primary.dark }}
        >
          <ArrowBackIcon />
        </IconButton>
        <Typography sx={{ fontSize: 18, textAlign: "center", flexGrow: 1 }}>
          Recipient Information
        </Typography>
      </Box>
      <form onSubmit={formik.handleSubmit}>
        <Box sx={{ mt: 2 }}>
          <AddressInputForm
            values={formik.values}
            handleChange={formik.handleChange}
            errors={formik.errors}
            touched={formik.touched}
            textFieldStyles={textFieldStyles}
          />
        </Box>
        <Grid item xs={12}>
          <Button
            fullWidth
            variant="contained"
            sx={{ mt: 2, bgcolor: theme.palette.primary.main }}
            type="submit"
          >
            Next
          </Button>
        </Grid>
      </form>
    </Container>
  );
};

export default RecipientInformation;
